export default (state = {}, {userId, res}: any) => {
  return {
    ...state,
    acceleratorBonusBanner: {
      [userId]: res,
    },
  };
};
